import React from 'react';

function getIEFallbackClass(scale) {
  if(scale >= 1) return 'loader--scale-1';
  if(scale === 0.5) return 'loader--scale-1-2';

}
export default function OverlayLoader({ active, scale = 1, background = 'none' }) {
  const wrapStyle = {
    background
  };
  const loaderStyle = {
    transform: `translate3d(-50%, calc(-50% - ${40 * scale}px), 0) scale(${scale})`
  };
  return active ? (
    <div className="loader-overlay" style={wrapStyle}>
      <div className="loader-fill">
        <div className={`loader ${getIEFallbackClass(scale)}`} style={loaderStyle} />
      </div>
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/parts/OverlayLoader.js